import React from 'react';
import {
  PlusOutlined,
} from '@ant-design/icons';
import { Button, Popover } from 'UI';
import { InventoryEntryTypeEnum } from 'constants/inventory';

import {
  MainContainer,
  ActionButton,
  PopoverContentWrapper,
} from './style';

interface CurrentInventoryExtraProps {
  onVisibleChange(isVisible: boolean): void
  onEntryClick(type?: InventoryEntryTypeEnum): void
  isPopoverVisible: boolean
}

const Extra = ({
  onVisibleChange,
  onEntryClick,
  isPopoverVisible,
}: CurrentInventoryExtraProps): JSX.Element => (
  <MainContainer>
    <Popover
      placement="bottomRight"
      trigger="click"
      visible={isPopoverVisible}
      onVisibleChange={onVisibleChange}
      content={(
        <PopoverContentWrapper>
          <ActionButton
            onClick={() => onEntryClick(InventoryEntryTypeEnum.INPUT)}
          >
            Entrada
          </ActionButton>
          <ActionButton
            onClick={() => onEntryClick(InventoryEntryTypeEnum.OUTPUT)}
          >
            Saída
          </ActionButton>
          <ActionButton
            onClick={() => onEntryClick(InventoryEntryTypeEnum.TRANSFER)}
          >
            Transferência
          </ActionButton>
        </PopoverContentWrapper>
      )}
    >
      <Button
        icon={<PlusOutlined size={14} />}
        onClick={() => onVisibleChange(!isPopoverVisible)}
      >
        Nova transação
      </Button>
    </Popover>
  </MainContainer>
);

export default Extra;
